import { ProjectSelectedStore } from "@/stores/project-selected-store";

export function urlWorkspaceQueryWriter(url: URL): string {
  const urlObj = new URL(url.toString());
  const workspace = ProjectSelectedStore.getInstance().value;
  const isGlobalWorkspaceResource =
    /^\/api\/workspace(?:\/|$)/.test(urlObj.pathname) ||
    /^\/api\/users\/me(?:\/|$)/.test(urlObj.pathname) ||
    /^\/api\/me\/workspace-context(?:\/|$)/.test(urlObj.pathname);
  if (
    isGlobalWorkspaceResource ||
    urlObj.pathname.match(/(workspace|(\/\d+\/{0,1})$)/gi) ||
    !workspace?.id ||
    urlObj.searchParams.has("workspace_id") ||
    urlObj.searchParams.get("workspaces__id")
  ) {
    return url.toString();
  }
  urlObj.searchParams.set("workspace__id", `${workspace.id}`);
  urlObj.searchParams.set("workspaces__id", `${workspace.id}`);
  return urlObj.toString();
}
